import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

export default function Profile() {
  const { user, profile, updateProfile, signOut, supabase } = useAuth();
  const [displayName, setDisplayName] = useState(profile?.display_name || '');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div style={{ maxWidth: '500px', margin: '60px auto', textAlign: 'center', padding: '20px' }}>
        <h2 style={{ fontFamily: "'Cinzel', serif", color: '#1a1714' }}>Profile</h2>
        <p style={{ color: '#6b6255' }}>Sign in to manage your profile.</p>
        <Link to="/" style={{ color: '#8b6914' }}>Back to calendar</Link>
      </div>
    );
  }

  async function handleSave() {
    setSaving(true);
    setMessage('');
    try {
      await updateProfile({ display_name: displayName || null });
      setMessage('Saved!');
    } catch (err) {
      setMessage('Error: ' + err.message);
    }
    setSaving(false);
  }

  async function handleDelete() {
    try {
      // Delete profile data (cascades to watchlist, alerts_sent)
      await supabase.from('profiles').delete().eq('id', user.id);
      await signOut();
      navigate('/');
    } catch (err) {
      setMessage('Error deleting account: ' + err.message);
    }
  }

  return (
    <div style={{ maxWidth: '500px', margin: '40px auto', padding: '20px' }}>
      <div style={{ marginBottom: '20px' }}>
        <Link to="/" style={{ color: '#8b6914', textDecoration: 'none', fontSize: '0.9rem' }}>Back to calendar</Link>
      </div>
      <h2 style={{ fontFamily: "'Cinzel', serif", color: '#1a1714', marginBottom: '24px' }}>Profile</h2>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '6px', color: '#2a2520', fontWeight: '600', fontSize: '0.9rem' }}>Email</label>
        <p style={{ color: '#6b6255' }}>{user.email}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '6px', color: '#2a2520', fontWeight: '600', fontSize: '0.9rem' }}>Display Name</label>
        <input
          type="text"
          value={displayName}
          onChange={e => setDisplayName(e.target.value)}
          placeholder="Your name"
          style={{ width: '100%', padding: '10px 12px', border: '1px solid #d4cec4', borderRadius: '4px', fontSize: '0.9rem', background: '#fff', color: '#2a2520', boxSizing: 'border-box' }}
        />
      </div>

      <button onClick={handleSave} disabled={saving} style={{ padding: '10px 24px', background: '#8b6914', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600' }}>
        {saving ? 'Saving...' : 'Save'}
      </button>
      {message && <p style={{ marginTop: '10px', color: message.startsWith('Error') ? '#cc4444' : '#4CAF50', fontSize: '0.85rem' }}>{message}</p>}

      <hr style={{ border: 'none', borderTop: '1px solid #d4cec4', margin: '30px 0' }} />

      <button onClick={signOut} style={{ padding: '8px 20px', background: 'none', border: '1px solid #6b6255', color: '#6b6255', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', marginRight: '12px' }}>
        Sign Out
      </button>

      {!confirmDelete ? (
        <button onClick={() => setConfirmDelete(true)} style={{ padding: '8px 20px', background: 'none', border: '1px solid #cc4444', color: '#cc4444', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem' }}>
          Delete Account
        </button>
      ) : (
        <div style={{ marginTop: '16px', padding: '16px', background: '#fde8e8', border: '1px solid #cc4444', borderRadius: '6px' }}>
          <p style={{ color: '#cc4444', fontWeight: '600', margin: '0 0 10px 0' }}>Are you sure? This will permanently delete your account, watchlist, and all data.</p>
          <button onClick={handleDelete} style={{ padding: '8px 16px', background: '#cc4444', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', marginRight: '8px' }}>
            Yes, Delete My Account
          </button>
          <button onClick={() => setConfirmDelete(false)} style={{ padding: '8px 16px', background: '#fff', border: '1px solid #d4cec4', color: '#2a2520', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem' }}>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
